if(!window.orgs_index){
  window.orgs_index = {
    list: [],
    ref: {},
    index: {},
    types: {}
  }
}

if(!window.groups_index){
  window.groups_index = {
    list: [],
    ref: {},
    index: {},
    types: {}
  }
}

const blank_states = {
  base: function () {
    return {
      data: {
        id: 0,
        type: 1,
        is_external: 0,
        data_type_id: 1,
        subtype: 0,
        firstname: '',
        lastname: '',
        main_email: 0,
        in_univers: '0'
      },
      type_opened: false,
      subtype_opened: false
      // ,
      // subtype_value: '',
      // type_value: ''
    }
  },
  emails: function () {
    return {
      data: {
        rel_id: -Math.floor(Math.random() * Math.floor(1000000)),
        data_type_id: 3,
        rel_type_id: 0,
        is_primary: 1,
        value: ''
      },
      type_opened: false
      // ,
      // rel_type_val: ''
    }
  },
  addresses: function () {
    return {
      data: {
        rel_id: -Math.floor(Math.random() * Math.floor(1000000)),
        data_type_id: 4,
        rel_type_id: 0,
        is_primary: 1,
        street: '',
        city: '',
        region: '',
        zip: '',
        country: '',
        extended: ''
      },
      type_opened: false
      // ,
      // rel_type_val: ''
    }
  },
  phones: function () {
    return {
      data: {
        rel_id: -Math.floor(Math.random() * Math.floor(1000000)),
        data_type_id: 5,
        rel_type_id: 0,
        is_primary: 1,
        value: ''
      },
      type_opened: false
      // ,
      // rel_type_val: ''
    }
  },
  websites: function () {
    return {
      data: {
        rel_id: -Math.floor(Math.random() * Math.floor(1000000)),
        data_type_id: 6,
        rel_type_id: 0,
        is_primary: 1,
        value: ''
      }
      // ,
      // rel_type_val: ''
    }
  },
  groups: function (list) {
    return {
      data: {
        rel_id: -Math.floor(Math.random() * Math.floor(1000000)),
        data_type_id: 7,
        rel_type_id: 0,
        is_primary: 1,
        value: 0
      },
      type_opened: false,
      subtype_opened: false,
      opened: false,
      input: '',
      display: '',
      type_id: 0,
      items: (typeof list !== 'undefined')? list : window.groups_index.list
    }
  },
  organizations: function (list) {
    return {
      data: {
        rel_id: -Math.floor(Math.random() * Math.floor(1000000)),
        data_type_id: 8,
        value: 0,
        rel_type_id: 0,
        is_primary: 1,
        service_id: 0
      },
      type_opened: false,
      opened: false,
      role_opened: false,
      service_opened: false,
      input: '',
      display: '',
      type_id: 0,
      items: (typeof list !== 'undefined')? list : window.orgs_index.list
    }
  },
  services: function () {
    return {
      data: {
        id: 0,
        data_type_id: 10,
        value: ''
      }
    }
  },
  notes: function () {
    return {
      data: {
        data_type_id: 9,
        value: ''
      }
    }
  }
}

const full_blank_state = function () {
  return {
    base: blank_states['base'](),
    emails: [blank_states['emails']()],
    addresses: [blank_states['addresses']()],
    phones: [blank_states['phones']()],
    websites: [blank_states['websites']()],
    groups: [blank_states['groups']()],
    organizations: [blank_states['organizations']()],
    services: [blank_states['services']()],
    notes: blank_states['notes']()
  }
}

export default {
  blank_states: blank_states,
  full_blank_state: full_blank_state
}
